export const transformActionFileData = (path: string) => {
  const pathParts = path.split('/');
  const name = pathParts.length > 1 ? pathParts.pop() || path : path;
  return {
    name,
    path,
  };
};
